import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ecNoOnlyWhiteSpacesValidator, NotificationService, setFormErrors } from '@cf/core';
import { ModalHeaderComponent } from '@cf/shared/dialog';
import {
  FormFieldComponent,
  InputDirective,
  InputErrorComponent,
} from '@cf/shared/forms/form-field';
import { ButtonComponent } from '@cf/shared/ui/button';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxTolgeeModule, TranslateService } from '@tolgee/ngx';
import { BookingApiService } from '../../services/booking-api.service';

@Component({
  selector: 'cf-booking-password',
  templateUrl: './booking-password-modal.component.html',
  styleUrl: './booking-password-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ModalHeaderComponent,
    ReactiveFormsModule,
    InputDirective,
    FormFieldComponent,
    InputErrorComponent,
    NgxTolgeeModule,
    ButtonComponent,
  ],
})
export class BookingPasswordModalComponent {
  translateService = inject(TranslateService);

  @Input() path!: string;

  @Input() username!: string;

  @Input() password!: boolean;

  form!: FormGroup;

  constructor(
    private readonly bookingApiService: BookingApiService,
    private readonly notificationService: NotificationService,
    private readonly activeModal: NgbActiveModal,
    private readonly fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      password: ['', [Validators.required, ecNoOnlyWhiteSpacesValidator]],
    });
  }

  checkPassword() {
    if (this.form.invalid) {
      return;
    }
    if (this.password) {
      if (this.form.controls.password.value === this.password) {
        this.activeModal.close(this.form.value.password);
        this.notificationService.success(this.translateService.instant('booking.correct_password'));
      } else {
        this.form.controls.password.setErrors({
          custom: this.translateService.instant('booking.incorrect_password'),
        });
      }
    } else {
      this.bookingApiService.checkPassword(this.path, this.username, this.form.value).subscribe({
        next: () => this.activeModal.close(this.form.value.password),
        error: (err) => {
          setFormErrors(this.form, err);
        },
      });
    }
  }
}
